import {
  StepInfo,
  GenderOption,
  PersonalDetailsFormFields,
  FormFields,
  StatutoryFormFields,
  KycFormFields,
} from 'components/EmployeeOnboarding/EmployeeSelfOnboarding/types';
import { routePaths } from 'components/Routes/data';

export const steps: StepInfo[] = [
  {
    id: 'kyc-info',
    title: 'KYC',
    step: 1,
    route: routePaths.employeeOnboarding.employeeSelfOnboarding.kycDetails,
  },
  {
    id: 'bank-details',
    title: 'Bank Details',
    step: 2,
    route: routePaths.employeeOnboarding.employeeSelfOnboarding.bankDetails,
  },
  {
    id: 'statutory-info',
    title: 'Statutory Information',
    step: 3,
    route: routePaths.employeeOnboarding.employeeSelfOnboarding.statutoryDetails,
  },
  {
    id: 'personal-details',
    title: 'Personal Details',
    step: 4,
    route: routePaths.employeeOnboarding.employeeSelfOnboarding.personalDetails,
  },
  {
    id: 'review-details',
    title: 'Review Details',
    step: 5,
    route: routePaths.employeeOnboarding.employeeSelfOnboarding.reviewDetails,
  },
];

export const routeToStepMap = steps.reduce((acc, step) => {
  acc[step.route] = step.step;
  return acc;
}, {} as Record<string, number>);

export const genderOptions: GenderOption[] = [
  { title: 'Male', value: 'm' },
  { title: 'Female', value: 'f' },
  { title: 'Other', value: 'o' },
];

export const kycFormInitialData: KycFormFields = {
  pan: '',
  aadharNumber: '',
  verificationConsent: false,
  panVerificationStatus: false,
};

export const statutoryFormInitialData: StatutoryFormFields = {
  pfUan: '',
  esicIpNumber: '',
  doNotHavePfUan: false,
  doNotHaveEsicIpNumber: false,
  isEsicEnabled: false,
  isPfEnabled: false,
};

export const personalFormInitialData: PersonalDetailsFormFields = {
  phoneNumber: '',
  enableWhatsapp: false,
  gender: [],
  dob: null,
};

export const formInitialData: FormFields = {
  ...kycFormInitialData,
  ...statutoryFormInitialData,
  ...personalFormInitialData,
};

export const maritalStatusOptions = [
  { title: 'Single', value: 'Single' },
  { title: 'Married', value: 'Married' },
  { title: 'Widow / Widower', value: 'Widow' },
  { title: 'Divorcee', value: 'Divorcee' },
] as const;

export const mandatoryPersonalFields = ['phone_number', 'gender', 'dob', 'enable_whatsapp'];

export type SpecialField = typeof specialFields[number];
export const specialFields = ['maritalStatus', 'marriageAnniversary', 'personalEmail'] as const;

//query and mutation keys
export const GET_SELF_ONBOARDING_DATA = 'GET_SELF_ONBOARDING_DATA';
